module.exports = __webpack_public_path__ + "assets/img/big-win.5fc292f3.png";